import createCache from "@emotion/cache";

// Use the emotion-insertion-point meta tag to control style injection order
export default function createEmotionCache() {
  return createCache({ 
    key: "css",
    insertionPoint: typeof document !== 'undefined' 
      ? document.querySelector('meta[name="emotion-insertion-point"]')
      : undefined,
  });
}

